import { render, staticRenderFns } from "./RemissionModalChangeProductComponent.vue?vue&type=template&id=4c4b73de"
import script from "./RemissionModalChangeProductComponent.vue?vue&type=script&lang=js"
export * from "./RemissionModalChangeProductComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports